export default __webpack_public_path__ + "static/media/PotentialImg.6f3e033e.jpg";